<template>
  <div class="row">
    <div class="col-3">
      {{ myfilename }}
    </div>
    <div class="col-3">
      <PrimeFileUpload name="demo[]" mode="basic" @select="select" accept=".mp3"  />
      <div v-if="myfilebase64">
            <button class="btn btn-success" @click="play()">
             <font-awesome-icon icon="play" />Play
            </button>
    </div>
    </div>
    <div class="col-3">
             {{ $Message }}
      
     
    </div>
  </div>
  
</template>

<script>
export default {
  name: "HelloWorld",
  props: {
        filename: String,
        filebase64: String,
    },
    emits: ['update:filename', 'update:filebase64']
,
created() {
     this.myfilename = this.filename;
     this.myfilebase64 = this.filebase64;
      if(this.myfilebase64 ){
      this.beeb = new Audio(this.myfilebase64);
      }
     
     
  },
  data() {
    return {
      isAddNew: false,
      item: null,
      selectedItems: null,
      myareacode: null,
      myfilename: null,
      myfilebase64: null,
      file: null,
      $Message: null,
      beeb: null,
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    agentNo() {
      return this.$store.state.user?.agentNo;
    },
    audio() {
      if (this.myfilebase64 && this.myfilebase64.length > 0) {
        return this.myfilebase64.substring(0, 100);
      } else {
        return "";
      }
    },
  },


  methods: {
    play() {
      console.log(this.beeb);
      this.beeb.play();
    },

    select(event) {
      var self = this;
      this.file = event.files[0];
      console.log(event.files[0]);

      self.myfilename = this.file.name;

      const FileExt = this.file.name.split(".").pop(); //取得檔案的字尾名
      if (this.file.size > 2097152) {
        //限制檔案的大小
        this.$Message = this.file.name + "大小超過2M!";
        this.file = null; //超過大小將檔案清空
      } else if (["mp3"].indexOf(FileExt.toLowerCase()) === -1) {
        //判斷檔案是否是mp3格式
        this.$Message = "請上傳以mp3結尾的檔案";
        this.file = null;
      } else {
        const reader = new FileReader(); //讀取檔案的字元流
        reader.readAsDataURL(this.file); //將檔案讀取為 DataURL 以data:開頭的字串
        reader.onload = (e) => {
          // 讀取到的圖片base64 資料編碼 將此編碼字串傳給後臺即可
          const code = e.target.result;
          //this.algorithmData.videoFiles = code
          self.myfilebase64 = code;
          self.beeb = new Audio(self.myfilebase64);
          console.log(self.myfilebase64);

         self.$emit('update:filename', self.myfilename)
         self.$emit('update:filebase64', self.myfilebase64)


        };
      }
      return false;
    },
  },
};
</script>
 